import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const items = [
  {
    q: "Qui peut concrètement prétendre aux subsides en Suisse ?",
    a: (
      <div className="space-y-3">
        <p>
          Toute personne domiciliée en Suisse dont le revenu déterminant ne
          dépasse pas les plafonds cantonaux. Notre service est spécifiquement
          optimisé pour accompagner&nbsp;:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Les Familles et Couples</strong> : pour cumuler les droits
            et protéger le budget du foyer.
          </li>
          <li>
            <strong>Les Jeunes Adultes (19-25 ans) et Étudiants</strong> : qui
            bénéficient de barèmes et de réductions spécifiques.
          </li>
          <li>
            <strong>Les Personnes Seules et Familles Monoparentales</strong> :
            souvent prioritaires selon les critères du RDU cantonal.
          </li>
        </ul>
      </div>
    ),
  },
  {
    q: "Comment est calculé mon droit aux subsides ?",
    a: (
      <p>
        Le calcul dépend de votre canton de domicile. À Genève, il se base sur
        le <strong>RDU (Revenu Déterminant Unifié)</strong> qui prend en compte
        votre revenu brut annuel après déductions forfaitaires et la composition
        de votre ménage. Notre simulateur intègre ces critères officiels pour
        vous fournir une estimation immédiate.
      </p>
    ),
  },
  {
    q: "Pourquoi passer par Swiss Premium Insurance plutôt que de faire la demande seul ?",
    a: (
      <p>
        Les critères cantonaux changent chaque année et une simple erreur dans
        la déclaration de vos revenus (brut vs net, déductions oubliées) peut
        entraîner un refus ou une baisse de votre aide. Nos conseillers valident
        votre dossier de A à Z pour vous assurer d'obtenir le montant maximal
        légal, sans perdre de temps avec l'administration.
      </p>
    ),
  },
  {
    q: "Votre simulateur de subside est-il payant ?",
    a: (
      <p>
        Non, l'utilisation de notre simulateur en ligne et la première estimation
        de vos droits sont <strong>100 % gratuites et sans engagement</strong>.
      </p>
    ),
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-white border-y border-slate-200"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center">
          <div className="text-xs tracking-[0.2em] uppercase font-bold text-spi-red mb-4">
            Questions fréquentes
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-spi-blue font-bold">
            Tout ce que vous devez savoir.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {items.map((it, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-semibold text-spi-blue">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
